<!-- Shared Prioritize legend plus the Programs Projects row once the version has a project. -->
<script lang="ts">
	import PrioritizeLegend from '../../legends/PrioritizeLegend.svelte';
	import InterventionsSubLegend from './InterventionsSubLegend.svelte';
	import { programsMapStore } from '../programs/programsMapStore.svelte';
	import { EPrioritize, ESafeCurvesModule } from '../interfaces';
	import { mapPriorityDisplayLabel } from '../../priority';
</script>

<PrioritizeLegend heading="Corridors" labels={mapPriorityDisplayLabel}>
	{#if programsMapStore.hasProjects}
		<h3 class="subHeading">Projects</h3>
		<InterventionsSubLegend
			moduleId={ESafeCurvesModule.Prioritize}
			systemId={EPrioritize.ProgramProjects} />
	{/if}
</PrioritizeLegend>

<style>
	.subHeading {
		margin-block: var(--space-3) var(--space-2);
		font-weight: var(--weight-semibold);
		font-size: var(--font-size-sm);
	}
</style>
